import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box, Tooltip, Fab, Menu, MenuItem } from '@mui/material';
import { useMutation } from 'react-fetching-library';
import AddIcon from '@mui/icons-material/Add';

import Scrollbar from '../../../../components-core/Scrollbar';
import EmptyContent from '../../../../components-core/EmptyContent';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components-core/data-grid/DataGridToolbar';
import { eventColumns } from '../../../../services/column-definitions';
import { duplicateEventAction } from '../../../../services/request';
import EventDetails from './EventDetails';
import SendMessageModal from './SendMessageModal';

export const EventList = props => {
  const { onOpenSidebar, hideSidebar, events, queryCallback, loading, submitCallback, allSeasons, allResorts, allAgeRanges, allCamps, setEvents } = props;
  const { mutate } = useMutation(duplicateEventAction);
  const [openModal, setOpenModal] = React.useState(false);
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [rowCount, setRowCount] = React.useState(0);
  const [rowsState, setRowsState] = React.useState({
    page: 0,
    pageSize: 10,
    rows: events,
    loading: false
  });
  const [editRowData, setEditRowData] = React.useState(null);
  const isEmpty = 2 < 1;

  const handleDetailsCheck = data => {
    setEditRowData(data);
    setFullScreen(true);
    setOpenCompose(true);
  };
  const [columns, setColumns] = React.useState(eventColumns(handleDetailsCheck));

  React.useEffect(() => {
    setRowsState({ ...rowsState, rows: events });
    setRowCount(events.length);
  }, [events]);

  const searchCallback = search => {
    queryCallback(search);
  };

  const [contextMenu, setContextMenu] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState(0);

  const handleContextMenu = event => {
    event.preventDefault();
    setSelectedRow(Number(event.currentTarget.getAttribute('data-id')));
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6
        }
        : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const handleDuplicate = async () => {
    const { error, payload } = await mutate(selectedRow);
    if (!error) {
      setEvents(prev => [payload, ...prev]);
      handleClose();
    } else {

    }
  };

  return (
    <Box sx={{ opacity: loading ? 0.5 : 1 }}>
      <EventDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
        allSeasons={allSeasons}
        allResorts={allResorts}
        allAgeRanges={allAgeRanges}
        allCamps={allCamps}
      />
      <Box display="flex" justifyContent="center">
        <Tooltip title="Dodaj zajęcia" sx={{ mb: 1 }}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => {
              setFullScreen(true);
              setOpenCompose(true);
            }}
          >
            <AddIcon style={{ fontSize: '30px' }} />
          </Fab>
        </Tooltip>
      </Box>
      {!isEmpty ? (
        <Scrollbar>
          <Box sx={{ minWidth: { md: 800 } }}>
            <DataGridPro
              columns={columns}
              rows={events}
              density="compact"
              disableColumnMenu={true}
              autoPageSize={false}
              autoHeight={true}
              rowsPerPageOptions={[10, 20]}
              pagination
              rowCount={rowCount}
              {...rowsState}
              onPageChange={page => setRowsState(prev => ({ ...prev, page, rows: events }))
              }
              onPageSizeChange={pageSize => setRowsState(prev => ({ ...prev, pageSize, rows: events }))
              }
              components={{
                Toolbar: DataGridToolbar
              }}
              componentsProps={{
                toolbar: { onOpenSidebar, hideSidebar, miniView: true, searchCallback },
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: 'context-menu' }
                }
              }}
              localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
              disableSelectionOnClick
              onRowClick={params => {
                setEditRowData(params.row);
                setOpenCompose(true);
              }}
              onRowDoubleClick={params => {
                setEditRowData(params.row);
                setFullScreen(true);
                setOpenCompose(true);
              }}
            />
            <Menu
              open={contextMenu !== null}
              onClose={handleClose}
              anchorReference="anchorPosition"
              anchorPosition={
                contextMenu !== null
                  ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                  : undefined
              }
              componentsProps={{
                root: {
                  onContextMenu: e => {
                    e.preventDefault();
                    handleClose();
                  }
                }
              }}
            >
              <MenuItem onClick={handleDuplicate}>Duplikuj</MenuItem>
              <MenuItem onClick={() => setOpenModal(true)}>Wyślij wiadomość</MenuItem>
            </Menu>
          </Box>
          {openModal ? <SendMessageModal open={openModal} handleClose={() => setOpenModal(false)} event={events.find(event => event.id === selectedRow)} /> : null}
        </Scrollbar>
      ) : (
        <EmptyContent
          title="Brak zamawiających"
          img="https://minimal-assets-api.vercel.app/assets/illustrations/illustration_empty_mail.svg"
          sx={{ flexGrow: 1, height: 'auto' }}
        />
      )}
    </Box>
  );
};

EventList.propTypes = {
  onOpenSidebar: PropTypes.func
};
